import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "./onboarding/NavbarForOnbardingForm";
import { useLoading } from "./LoadingContext";

function CopyAddClient() {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the job id from the URL parameters

  const [clientData, setClientData] = useState({
    client_id: "",
    client_name: "",
    client_country: "",
    client_city: "",
    client_contact_number: "",
    client_mail_id: "",
    client_contact_person: "",
    client_contact_person_mail_id: "",
    client_contact_person_phone_number: "",
    engagement_type: "",
  });

  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  // Handle input changes for all form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientData((prevState) => ({
      ...prevState,
      [name]: value || "", // Ensure controlled input with empty string
    }));
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();

    const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/client-api/clients/`;
    const headers = {
      "Content-Type": "application/json",
    };

    // Send data to the API
    axios
      .post(apiEndpoint, clientData, { headers })
      .then((response) => {
        // console.log(response.data);
        navigate("/client_dashboard");
      })
      .catch((error) => {
        // Alert error message if available
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Failed to Add Client");
        }
        console.error(error);
      });
  };

  // Fetch client data based on the id from URL parameters
  useEffect(() => {
    setLoading(true);
    if (id) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/client-api/clients/${id}/`)
        .then((response) => {
          const fetchedData = response.data.data;
          // Set default values to avoid uncontrolled input errors
          setClientData({
            client_id: fetchedData.client_id || "",
            client_name: fetchedData.client_name || "",
            client_country: fetchedData.client_country || "",
            client_city: fetchedData.client_city || "",
            client_contact_number: fetchedData.client_contact_number || "",
            client_mail_id: fetchedData.client_mail_id || "",
            client_contact_person: fetchedData.client_contact_person || "",
            client_contact_person_mail_id:
              fetchedData.client_contact_person_mail_id || "",
            client_contact_person_phone_number:
              fetchedData.client_contact_person_phone_number || "",
            engagement_type: fetchedData.engagement_type || "",
          });
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            alert(error.response.data.message);
          } else {
            alert("An unexpected error occurred. Please try again.");
          }
          setError(error);
          setLoading(false);
        });
    } else {
      setLoading(false); // If no id, don't load data
    }
  }, [id]);

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">Data is Fetching.... </h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-6 log">
            <div className="card border border-dark text-dark">
              <div
                className="card-header border-dark text-white"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">Add Client Form</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit} className="text-dark">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="client_id" className="form-label">
                          Id
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_id"
                          name="client_id"
                          aria-describedby="emailHelp"
                          value={clientData.client_id}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="client_name">
                            Name
                          </label>
                          <input
                            type="text"
                            id="client_name"
                            name="client_name"
                            className="form-control border-dark text-dark"
                            value={clientData.client_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label
                            className="form-label"
                            htmlFor="client_country"
                          >
                            Country
                          </label>
                          <input
                            type="text"
                            id="client_country"
                            name="client_country"
                            className="form-control border-dark text-dark"
                            value={clientData.client_country}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_mail_id" className="form-label">
                          Mail Id
                        </label>
                        <input
                          type="mail"
                          className="form-control border-dark text-dark"
                          id="client_mail_id"
                          name="client_mail_id"
                          aria-describedby="emailHelp"
                          value={clientData.client_mail_id}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_number"
                          className="form-label"
                        >
                          Contact Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="client_contact_number"
                          name="client_contact_number"
                          aria-describedby="emailHelp"
                          // pattern="(\+91)?[6-9][0-9]{9}"
                          value={clientData.client_contact_number}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="client_city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_city"
                          name="client_city"
                          aria-describedby="emailHelp"
                          value={clientData.client_city}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person"
                          className="form-label"
                        >
                          Contact Person
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person"
                          name="client_contact_person"
                          aria-describedby="emailHelp"
                          value={clientData.client_contact_person}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person_mail_id"
                          className="form-label"
                        >
                          Contact Person Mail Id
                        </label>
                        <input
                          type="email"
                          className="form-control border-dark text-dark"
                          id="client_contact_person_mail_id"
                          name="client_contact_person_mail_id"
                          aria-describedby="emailHelp"
                          value={clientData.client_contact_person_mail_id}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="engagement_type" className="form-label">
                          Engagement Type
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="engagement_type"
                          name="engagement_type"
                          aria-describedby="emailHelp"
                          value={clientData.engagement_type}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label
                          htmlFor="client_contact_person_phone_number"
                          className="form-label"
                        >
                          Contact Person Phone Number
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="client_contact_person_phone_number"
                          name="client_contact_person_phone_number"
                          aria-describedby="emailHelp"
                          value={clientData.client_contact_person_phone_number}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-center py-2">
                    <button type="submit" className="btn btn-outline-info me-2">
                      Submit
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/client_dashboard")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CopyAddClient;
